export const API_URL = process.env.NODE_ENV === 'production'
  ? 'https://nojuice.herokuapp.com/api'
  : '/api'

export const WSS_URL = (process.env.NODE_ENV === 'production') 
  ? 'ws://nojuice.herokuapp.com:443'
  : 'ws://localhost:4005'
  // ? `ws://nojuice.herokuapp.com:${process.env.PORT}`